<div class="custom-row">
  @if (canEdit) {
    <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="openDialog()"></ppl-button>
  }
</div>

@if (tableData.length > 0) {
  <ppl-list-table [cols]="cols" [data]="tableData" [disableSort]="true" [disableSearch]="true"
    [showCustomSearch]="false" [enableActions]="false" [disableSelection]="true" [gridTitle]="false"
    [pagination]="false" [loadPage]="false"></ppl-list-table>
} @else {
  <p>No parent/guardian information provided.</p>
}

<ppl-popup-dialog [(isVisible)]="showDialog" [title]="'Parent/Guardian Information'" [size]="'large'"
  [position]="'middle'" [showClose]="true" [showButtons]="false" (cancel)="closeDialog()">
  @if (showDialog) {
    <div class="pg-dialog-body">
      <ppl-parent-guardian [parents]="parents" [validationErrors]="validationErrors"
        [addressErrors]="parentAddressErrors"
        (deleteSavedRecords)="onDeleteSavedRecords($event)"></ppl-parent-guardian>
    </div>
    <div class="custom-row ppl-mt16">
      <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="closeDialog()"></ppl-button>
      <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="save()"></ppl-button>
    </div>
  }
</ppl-popup-dialog>
